/*
 * THTD — Standard Storefront Events bootstrap (T1)
 * Establishes a single readiness gate for Shopify's Standard Storefront Events library
 * (https://cdn.shopify.com/storefront/standard-events.js), which theme.liquid loads as a
 * module and assigns to window.Shopify.StandardEvents. All event-dispatch code waits on
 * THTD.onSEReady so it no-ops gracefully if the CDN import never resolves.
 *
 * Plain (non-module) script — loaded early in body-scripts.liquid, before udesly.
 * Observability only: never alters storefront behaviour or UI.
 */
(function () {
  if (window.__thtd_se_bootstrap) return;
  window.__thtd_se_bootstrap = true;

  window.THTD = window.THTD || {};

  var ready = !!(window.Shopify && window.Shopify.StandardEvents);
  var queue = [];

  function flush() {
    ready = true;
    var SE = window.Shopify && window.Shopify.StandardEvents;
    while (queue.length) {
      var cb = queue.shift();
      try { cb(SE); } catch (e) { /* a consumer must never break the page */ }
    }
  }

  /**
   * Register a callback that receives the StandardEvents namespace once it is available.
   * Fires immediately if already loaded; otherwise waits for the module's ready signal.
   */
  window.THTD.onSEReady = function (cb) {
    if (typeof cb !== 'function') return;
    if (ready && window.Shopify && window.Shopify.StandardEvents) {
      try { cb(window.Shopify.StandardEvents); } catch (e) {}
      return;
    }
    queue.push(cb);
  };

  /**
   * Shared, briefly-memoized /cart.js reader. After an add, the cart-events wrap (T2),
   * the cart:view bridge (T4) and Udesly itself can each want the cart — memoize for a
   * short window so we don't hammer /cart.js. Pass a specific fetch impl (e.g. the
   * pre-wrap original) to avoid going through a wrapped fetch.
   */
  var _cartCache = null;
  var _cartCacheAt = 0;
  window.THTD.cartJSON = function (fetchImpl, maxAgeMs) {
    var f = fetchImpl || window.fetch;
    var maxAge = typeof maxAgeMs === 'number' ? maxAgeMs : 250;
    var now = Date.now();
    if (_cartCache && (now - _cartCacheAt) < maxAge) return _cartCache;
    _cartCacheAt = now;
    _cartCache = Promise.resolve()
      .then(function () { return f('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .catch(function (e) { _cartCache = null; throw e; });
    return _cartCache;
  };

  // The module script (theme.liquid, above content_for_header) dispatches this once it has
  // assigned window.Shopify.StandardEvents. We also poll briefly as a belt-and-suspenders
  // fallback in case the event fired before this script parsed.
  document.addEventListener('thtd:standard-events-ready', flush, { once: true });

  if (!ready) {
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (window.Shopify && window.Shopify.StandardEvents) { clearInterval(poll); flush(); }
      else if (tries > 100) { clearInterval(poll); } // ~10s; give up silently
    }, 100);
  }
})();
